import React, { Component } from 'react'
// import { deepOrange } from '@material-ui/core/colors';
import { getDarkMode } from '../Helper/CommonThings';
import { getCookie, setCookie } from '../Utils/CookieHelper';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { Avatar, Box, CircularProgress, CssBaseline, Dialog, DialogContent, DialogTitle, Divider, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Popover, Toolbar, Tooltip, Typography, styled } from '@mui/material';
import ProjectManagement from '../ProjectManagement/ProjectManagement';
import Service from '../Networking/NetworkingUtils';
import ChangePassword from './ChangePassword';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MyProjectList from '../ProjectList/MyProjectList';
import ListAltIcon from '@mui/icons-material/ListAlt';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import ModelStore from '../ModelStore/ModelStore';
import OpenProjectStore from '../ProjectStore/OpenProjectStore';
import ModelCategory from '../ModelCategory/ModelCategory';
import ContactsIcon from '@mui/icons-material/Contacts';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import UserAccess from '../Users/User';
import SnackbarUtils from '../SnackbarUtils/SnackbarUtlis';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import WebglUpload from '../WebglUpload/WebglUpload';
import AccessGroup from '../AccessGroup/AccessGroup';
import { deepOrange } from '@mui/material/colors';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Client from '../Client/Client';
import BusinessIcon from '@mui/icons-material/Business';

var token = getCookie("bb_metaverse_token");
var access = JSON.parse(getCookie("bb_metaverse_access"));

const ToolbarStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const AvatarStyled = styled(Avatar)(({ theme }) => ({
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    width: theme.spacing(4),
    height: theme.spacing(4),
}));

const StyledListItem = styled(ListItemButton)(({ theme }) => ({
    "&&.Mui-selected": {
        backgroundColor: "#CFE9F8",
        color: "#000",
    },
    "&&.Mui-selected:hover": {
        backgroundColor: "#CFE9F8",
        color: "#000",
    },
    "&:hover": {
        color: getDarkMode() === "dark" ? "#fff" : "#000",
    },
}));

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                marginLeft: drawerWidth,
                width: `calc(100% - ${drawerWidth}px)`,
                transition: theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
        },
    ],
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        variants: [
            {
                props: ({ open }) => open,
                style: {
                    ...openedMixin(theme),
                    '& .MuiDrawer-paper': openedMixin(theme),
                },
            },
            {
                props: ({ open }) => !open,
                style: {
                    ...closedMixin(theme),
                    '& .MuiDrawer-paper': closedMixin(theme),
                },
            },
        ],
    }),
);

class Home extends Component {
    constructor(props) {
        super()
        this.feedback = React.createRef();
        this.state = {
            openDrawer: false,
            viewClass: '',
            open: false,
            formValue: false,
            userData: {},
            isLoading: true,
            menus: [],
            passwordDialog: false,
            aboutorContactDialog: false,
            isAbout: false,
        }
    }

    componentDidMount() {
        if (access) {
            access = JSON.parse(getCookie("bb_metaverse_access"));
        }

        token = getCookie("bb_metaverse_token");

        if (!getCookie("bb_metaverse_token")) {
            window.location.href = '/'
        } else {
            if (!getCookie("bb_metaverse_user")) {
                Service.get(`/rest-auth/user/`, {
                    headers: {
                        Authorization: "Token " + token,
                    },
                })
                    .then(res => {
                        setCookie('bb_metaverse_user', JSON.stringify(res.data), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
                        // this.props.enqueueSnackbar('Welcome back ' + res.data.first_name + '!', {
                        //     variant: 'info'
                        // });
                        SnackbarUtils.success('Welcome back ' + res.data.first_name + '!');
                        this.createMenu(res.data);
                        this.setState({
                            isLoading: false,
                            userData: res.data,
                        });

                    })
                    .catch(error => {
                        console.log(error)
                        SnackbarUtils.error('Something went wrong!');
                        // this.props.enqueueSnackbar('Something went wrong!', {
                        //     variant: 'error'
                        // });
                    });

                this.getAccess();
            } else {
                const user = JSON.parse(getCookie("bb_metaverse_user"));

                // this.props.enqueueSnackbar('Welcome back ' + user.first_name + '!', {
                //     variant: 'info'
                // });
                SnackbarUtils.success('Welcome back ' + user.first_name + '!');
                this.createMenu(user);
                this.setState({
                    isLoading: false,
                    userData: user,
                });
            }
        }
    }

    getAccess() {
        Service.get(`/api/token/access/get_token_access_permissions/`, {
            headers: {
                Authorization: "Token " + getCookie("bb_metaverse_token"),
            },
        })
            .then(res => {
                if (res.data && res.data[0]) {
                    if (access) {
                        if (access.last_updated !== res.data[0].last_updated) {
                            setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
                            // accessReloadOrRefresh();
                            window.location.reload();
                        }
                    } else {
                        setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
                        // accessReloadOrRefresh();
                        window.location.reload();
                    }

                } else {
                    setCookie('bb_metaverse_access', JSON.stringify({}), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
                    // alert("This user doesn't have basic access")
                }

            })
            .catch(error => {
                setCookie('bb_metaverse_access', JSON.stringify({}), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
            });
    }

    openContactorAbout(value) {
        this.setState({
            aboutorContactDialog: true,
            isAbout: value
        })
    }

    createMenu(userData) {
        var accessBuild = [];
        var defaultView = '';
        var hashDone = false;

        var viewHash = window.location.hash.split('?')[0].replace('#', '').replace('%20', ' ').replace('%20', ' ');

        if (viewHash === "My Projects") {
            hashDone = true;
            this.setState({
                viewClass: viewHash,
            })

        }
        accessBuild.push("My Projects")
        defaultView = 'My Projects'

        if (userData.email && userData.email.includes('@balfourbeatty.com')) {
            accessBuild.push('Project Store')
        }



        if (access && access.access) {
            if ((access.access.l0a && access.access.l0a.l0a_a) || (access.access.l0a && access.access.l0a.l0a_b)) {

                if (viewHash === 'Project Management') {
                    hashDone = true;
                    this.setState({
                        viewClass: viewHash,
                    })
                }
                accessBuild.push('Project Management')


                if (viewHash === 'Model Category') {
                    hashDone = true;
                    this.setState({
                        viewClass: viewHash,
                    })
                }
                accessBuild.push('Model Category')

                if (viewHash === 'Model Store') {
                    hashDone = true;
                    this.setState({
                        viewClass: viewHash,
                    })
                }
                accessBuild.push('Model Store')


            }

            if (access.access.l0b && access.access.l0b.l0b_a) {
                if (viewHash === 'Webgl Template') {
                    hashDone = true;
                    this.setState({
                        viewClass: viewHash,
                    })
                }

                accessBuild.push('Webgl Template')
            }

            if (access.access.l0c && access.access.l0c.l0c_a) {
                if (viewHash === 'Client Management') {
                    hashDone = true;
                    this.setState({
                        viewClass: viewHash,
                    })
                }
                accessBuild.push('Client Management')
            }
        }




        if (userData.manage_user) {
            if (viewHash === 'Manage User') {
                hashDone = true;
                this.setState({
                    viewClass: viewHash,
                })
            }
            accessBuild.push('Manage User')
        }

        if (viewHash === 'Group Access') {
            hashDone = true;
            this.setState({
                viewClass: viewHash,
            })
        }
        accessBuild.push('Group Access')


        if (hashDone) {
            this.setState({
                menus: accessBuild,
            })
        } else {
            this.setState({
                menus: accessBuild,
                viewClass: defaultView,
            })
        }
    }

    render() {
        // const { classes } = this.props;

        const handleDrawerOpen = () => {
            this.setState({
                openDrawer: true,
            })
        };

        const handleDrawerClose = () => {
            this.setState({
                openDrawer: false,
            })
        };

        const handleViewChange = (e, val) => {
            if (!getCookie("bb_metaverse_token")) {
                window.location.href = '/'
            } else {
                window.location.hash = val;
                this.setState({
                    viewClass: val,
                })
            }
        };

        const darkMode = () => {
            // if (localStorage.getItem("theme_mode")) {
            //     localStorage.removeItem("theme_mode");
            // } else {
            localStorage.setItem("theme_mode", `${getDarkMode() === 'dark' ? 'light' : 'dark'}`)
            // }
            window.location.reload()
        }

        // const Logout = () => {
        //     deleteCookie("bb_metaverse_user")
        //     deleteCookie("bb_metaverse_token")
        //     window.location.href = '/'
        // }

        // const changePassword = () => {
        //     this.setState({
        //         passwordDialog: true
        //     })
        // }

        const handleDialogClose = () => {
            this.setState({
                passwordDialog: false
            })
        }

        return (
            <>
                {this.state.viewClass.length === 0 ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: window.innerHeight }}>
                        <Typography>
                            You do not have access to any tabs
                        </Typography>
                    </Box>
                ) : (
                    <>
                        {this.state.isLoading ? (
                            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box>
                        ) : (
                            <Box sx={{ display: 'flex' }}>
                                <CssBaseline />
                                <AppBar position="fixed" open={this.state.openDrawer} enableColorOnDark>
                                    <Toolbar>
                                        <Box flexGrow={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <IconButton
                                                color="inherit"
                                                aria-label="open drawer"
                                                onClick={handleDrawerOpen}
                                                edge="start"
                                                sx={[
                                                    {
                                                        marginRight: 3,
                                                    },
                                                    this.state.openDrawer && { display: 'none' },
                                                ]}
                                            >
                                                <MenuIcon />
                                            </IconButton>
                                            <Typography variant="h6" noWrap component="div">
                                                BBverse
                                            </Typography>
                                        </Box>
                                        <Box sx={{ marginRight: "15px", cursor: 'pointer' }} onClick={() => this.openContactorAbout(true)}>
                                            About
                                        </Box>
                                        <Tooltip title="Contact" arrow>
                                            <ContactsIcon sx={{ mr: 2, fontSize: '20px', cursor: 'pointer' }} onClick={() => this.openContactorAbout(false)} />
                                        </Tooltip>
                                        <Tooltip title="Dark Mode" arrow>
                                            <Brightness4Icon sx={{ mr: 2, fontSize: '20px', cursor: 'pointer' }} onClick={darkMode} />
                                        </Tooltip>
                                        <PopupState variant="popover" popupId="demo-popup-popover">
                                            {(popupState) => (
                                                <div>
                                                    <AvatarStyled  {...bindTrigger(popupState)}  ><Box fontSize={12}>{this.state.userData.first_name.charAt(0).toUpperCase() + this.state.userData.last_name.charAt(0).toUpperCase()}</Box></AvatarStyled>
                                                    <Popover {...bindPopover(popupState)}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'center',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'center',
                                                        }}>
                                                        <Box sx={{ width: 280, m: 1, p: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center', gap: 1 }}>
                                                            <Avatar sx={{ backgroundColor: "secondary.main", color: 'primary.main', width: 60, height: 60 }}>{this.state.userData.first_name.charAt(0).toUpperCase() + this.state.userData.last_name.charAt(0).toUpperCase()}</Avatar>
                                                            <Typography >{this.state.userData.first_name + " " + this.state.userData.last_name}</Typography>
                                                            <Typography variant="caption">{this.state.userData.email}</Typography>
                                                        </Box>
                                                    </Popover>
                                                </div>
                                            )}
                                        </PopupState>
                                    </Toolbar>
                                </AppBar>
                                <Drawer variant="permanent" anchor="left" open={this.state.openDrawer}>
                                    <ToolbarStyled>
                                        <IconButton onClick={handleDrawerClose}>
                                            <ChevronLeftIcon />
                                        </IconButton>
                                    </ToolbarStyled>
                                    <Divider />
                                    <List>
                                        {this.state.menus.map((text, index) => (
                                            <Tooltip title={text} aria-label={text} key={text}>
                                                <StyledListItem button key={text} onClick={e => handleViewChange(e, text)} selected={this.state.viewClass === text} >
                                                    <ListItemIcon>
                                                        {text === "Project Management" ? <AssignmentIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                            text === "Manage User" ? <PersonAddIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                                text === "My Projects" ? <ListAltIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                                    text === "Model Category" ? <CollectionsBookmarkIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                                        text === "Project Store" ? <StorefrontIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                                            text === "Model Store" ? <LocalShippingIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                                                text === 'Webgl Template' ? <CloudUploadIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> :
                                                                                text === 'Client Management' ? <BusinessIcon color={this.state.viewClass === text ? "primary" : 'inherit'} /> 
                                                                                    : <AssignmentIcon />
                                                        }
                                                    </ListItemIcon>
                                                    {this.state.openDrawer && <ListItemText primary={text} />}
                                                </StyledListItem>
                                            </Tooltip>
                                        ))}
                                    </List>
                                </Drawer>

                                <Box component="main" sx={{ flexGrow: 1, p: 2, mt: 8 }}>
                                    {
                                        (this.state.viewClass === "Manage User") ? (
                                            <UserAccess />
                                        ) : (this.state.viewClass === "Project Management") ? (
                                            <ProjectManagement />
                                        ) : (this.state.viewClass === "My Projects") ? (
                                            <MyProjectList />
                                        ) : (this.state.viewClass === "Project Store") ? (
                                            <OpenProjectStore isMsalAuthenticated={true} />
                                        ) : (this.state.viewClass === "Model Category") ? (
                                            <ModelCategory />
                                        ) : (this.state.viewClass === "Model Store") ? (
                                            <ModelStore />
                                        ) : (this.state.viewClass === "Webgl Template") ? (
                                            <WebglUpload />
                                        ) : (this.state.viewClass === "Group Access") ? (
                                            <AccessGroup />
                                        ) : (this.state.viewClass === "Client Management") ? (
                                            <Client />
                                        ) : (
                                            null
                                        )
                                    }
                                </Box>
                            </Box>
                        )}
                        <Dialog fullWidth={true} maxWidth="xs" disableEnforceFocus open={this.state.passwordDialog} onClose={handleDialogClose} >
                            <DialogTitle>Change Password</DialogTitle>
                            <DialogContent>
                                <ChangePassword close={handleDialogClose} email={this.state.userData.email} />
                            </DialogContent>
                        </Dialog>
                        <Dialog maxWidth={this.state.isAbout ? 'md' : 'xs'} disableEnforceFocus open={this.state.aboutorContactDialog} onClose={() => this.setState({ aboutorContactDialog: false })} >
                            <DialogTitle>
                                <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                                    <Box flexGrow={1} >
                                        <Typography variant="h6" >
                                            {this.state.isAbout ? 'About' : 'Contact'}
                                        </Typography>
                                    </Box>
                                    <IconButton onClick={() => this.setState({ aboutorContactDialog: false })}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent>
                                {this.state.isAbout ? <div>
                                    <b>Scope:</b><br />
                                    Two modes of delivery vision is agreed.<br />
                                    1. <b>Service Delivery:</b> Project teams will provide the scope, design brief including any site scan, and models information available to Digital Team to create further required models, collate models, integrate programme (p6, asta, excel, MS project, etc), to either develop a 3D or 4D sequence to output in video or synchro or fuzor or XR or AR or VR app
                                    The outputs will be distributed via BBverse platform for the project users (unlimited without requirement for any new software installations or licensing cost)<br />

                                    2. <b>Self Service Delivery:</b> The application will have functionality for the project users to import 3D models, programme, machineries/equipments, and develop a sequence collaboratively between multiple discipline stakeholders within BB, and to manage the project workspace <br />
                                    For this Proof Of Concept (POC), The Digital Rehearsal application, scope is limited.<br />

                                    This POC UAT 1 is part of the Service Delivery model, and not all functions are developed yet. Users are provided with minimum required functionalities to test the Proof Of Concept output,<br />
                                    to provide feedback, and define further requirements which help IT to assess if the application can be further developed, to realise potential benefits.<br /><br />

                                    <b>Scope limited for this POC UAT 1 :</b><br />
                                    1.User can experience the sample ( A57 ) serviced interactive 4D construction sequence<br />
                                    2.Play/Pause the sequence at any given date<br />
                                    3.Navigate, rotate and zoom in to inspect the elements of work<br />
                                    4.Introspect dates & active tasks<br />
                                    5.Provide quick reviews of the output. As its cloud based real time, any stakeholder within the project can view other reviews, status, comments to track<br />
                                    6.Examining metadata of 3D models (as of now limited only to model design information)<br />
                                    7.Visualize the clearance of space effectively, collaborate with site team for clashes, safety requirements<br />
                                    8.Interact with the Timeline to run back / forth the 4D sequence<br />
                                    9.This A57 project terrain is a direct import of drone survey in site scan. Offline functionalities are available to change the site scan imagery from different dates of drone surveys<br />
                                </div> :

                                    <div>For Service Delivery for one of your projects,<br />
                                        contact : tom.bush@balfourbeatty.com <br />
                                        suresh.rajamanikkam@balfourbeatty.com <br />
                                        UK & EDC coordinators for Digital & Animation <br /><br />

                                        For technical issues in BBverse, contact <br />
                                        venkata.rathinam@balfourbeatty.com<br />
                                    </div>}
                            </DialogContent>
                        </Dialog>
                    </>
                )}
            </>
        )
    }
}


export default Home;